import { render, staticRenderFns } from "./StudentClassForm.vue?vue&type=template&id=e68cd56c&scoped=true"
import script from "./StudentClassForm.vue?vue&type=script&lang=js"
export * from "./StudentClassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68cd56c",
  null
  
)

export default component.exports